import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BASE_URL_SERVICE } from 'src/app/app.module';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';

export function AccessPeriodoCamGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idPeriodo', id);

            return http.get<boolean>(baseUrl + 'api/mantenimiento/main/AccessPeriodo/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}
